import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import ButtonGroup from '@material-ui/core/ButtonGroup';

export const TopNavBarButtonGroup = withStyles(theme => ({
	root: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white,
		borderRadius: 10,
		borderColor: theme.palette.primary.dark,
		textTransform: 'none',
		minHeight: 32,
		maxHeight: 32,
	},
	groupedOutlined: {
		//fixes separating border not visible when using background color
		'&:not(:first-child)': {
			borderLeftColor: theme.palette.primary.dark,
		},
	},
}), {name: 'TopNavBarButtonGroup'})(ButtonGroup);